// extracted by mini-css-extract-plugin
export default {"perk":"bxrCo","perkInfo":"dyb0r","perkTitle":"_12lGb","unselectable":"_3HReR","lockedPerk":"_3zuEt","plugStats":"_2yzpm","iconContainer":"_2EKbI","requirement":"_1d2Xa"};